export enum SyncingModels {
    EditableEmployeeSheet = 'EditableEmployeeSheet',
    PayrollApprovalSheet = 'PayrollApprovalSheet',
    ApprovalSheet = 'ApprovalSheet',
    OfferLetterTemplatesSettings = 'OfferLetterTemplatesSettings',
    Users = 'Users',
    PayRanges = 'PayRanges',
    EafApproval = 'EafApproval',
}
